export interface CaldavDTO {
    id: number;
    userId: number;
    url: string;
    username: string;
    password: string;
}

export interface CaldavWriteDTO {
    userId: number;
    url: string;
    username: string;
    password: string;
}

export function createCaldav(userId: number,
    url: string,
    username: string,
    password: string
) {
    return { userId: userId, url: url, username: username, password: password }
}